export enum EventGroupsTab {
  ACTIVE = 'active',
  INACTIVE = 'inactive',
  ALL = 'all',
}

export interface IEndEventGroupConfirmationOptions {
  endDate: Date;
}
